import PropTypes from "prop-types";

export default function UploadFileCard({ index, file, removeFile }) {
  return (
    <div
      key={index}
      className=" rounded-lg flex items-center bg-[#1B5C2926] px-4 py-2 text-sm"
    >
      <span className="max-w-[200px] truncate">{file.fileName}</span>
      <button
        onClick={() => removeFile(index)}
        className="ml-2 text-red-500 text-2xl cursor-pointer"
      >
        ×
      </button>
    </div>
  );
}

UploadFileCard.propTypes = {
  index: PropTypes.number.isRequired,
  file: PropTypes.shape({
    fileName: PropTypes.string.isRequired,
  }).isRequired,
  removeFile: PropTypes.func.isRequired,
};